import React from 'react';
import { ThemeProvider, CSSReset, Flex } from '@chakra-ui/core';
import theme from './theme';
import Body from './Body';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CSSReset />
      <Flex
        as="main"
        width="100%"
        minH="100vh"
        align="flex-start"
        justify="flex-start"
        pl={[6, 8, 12, 24]}
        pr={[6, 8, 12, 16]}
        py={[8, 10, 12, 16]}
      >
        <Body />
      </Flex>
    </ThemeProvider>
  );
}

export default App;
